import { SetStateAction } from "react";
import { Button } from "components/atoms";
import { ConditionalClassBtns } from "./ConditionalClassBtns";
import { ConditionalTopicFocusBtns } from "./ConditionalTopicFocusBtns";
import { decodeToken } from "utils/functions/decodeToken";
import { useAppDispatch, useScreenSize } from "hooks";
import { MOBILE_WIDTH } from "utils/constants";
import "./index.scss";
import { openExternalUrl } from "utils/functions/openExternalUrl";

interface IProps {
  segment: any;
  index?: number;
  refreshModalState?: SetStateAction<any>;
  handleScoreReportModalOpen?: (url: string) => void;
}

export const ConditionalBtns = ({
  segment,
  index,
  refreshModalState,
  handleScoreReportModalOpen,
}: IProps): any => {
  const payload = decodeToken();
  const dispatch = useAppDispatch();

  const testtype = payload?.testtype;

  const screen = useScreenSize();

  if (
    segment &&
    segment.IsTestSegment === false &&
    segment.IsTopicFocusSegment === false
  ) {
    return (
      <ConditionalClassBtns
        segment={segment}
        index={index}
      />
    );
  } else if (
    segment &&
    segment.IsTestSegment === false &&
    segment.IsTopicFocusSegment === true
  ) {
    return (
      <ConditionalTopicFocusBtns
        segment={segment}
        index={index}
      />
    );
  } else if (
    segment &&
    segment.IsTestSegment === true &&
    (segment.ExamCo.ContentObjectType === "AAMC" ||
      segment.ExamCo.ContentObjectType === "Exam" ||
      segment.ExamCo.ContentObjectType === "SubjectExam")
  ) {
    if (segment.ExamCo.Status === "Not Started") {
      return (
        <div className="btn-wrapper">
          <Button
            onClick={() => {
              openExternalUrl({
                url: segment.ExamCo.LaunchUrl,
                contentObjectType: segment.ExamCo.ContentObjectType,
                testType: testtype,
                dispatch,
                onRefreshModalOpen:
                  screen.width > MOBILE_WIDTH && refreshModalState
                    ? (contentType) =>
                        refreshModalState((prev: any) => ({
                          ...prev,
                          isOpen: true,
                          data: contentType || segment.ExamCo.ContentObjectType || "Test",
                        }))
                    : undefined,
              });
            }}
            label="Start Online Test"
            type="score"
            icon={false}
            btnId={`home-btn-${index}`}
          />
        </div>
      );
    } else if (segment.ExamCo.Status === "In Progress") {
      return (
        <div className="btn-wrapper">
          <Button
            onClick={() => {
              openExternalUrl({
                url: segment.ExamCo.LaunchUrl,
                contentObjectType: segment.ExamCo.ContentObjectType,
                testType: testtype,
                dispatch,
                onRefreshModalOpen:
                  screen.width > MOBILE_WIDTH && refreshModalState
                    ? (contentType) =>
                        refreshModalState((prev: any) => ({
                          ...prev,
                          isOpen: true,
                          data: contentType || segment.ExamCo.ContentObjectType || "Test",
                        }))
                    : undefined,
              });
            }}
            label="Resume"
            type="score"
            icon={false}
            btnId={`home-btn-${index}`}
          />
        </div>
      );
    } else {
      return (
        <div className="btn-wrapper">
          <Button
            onClick={() => {
              handleScoreReportModalOpen && handleScoreReportModalOpen(segment.ExamCo.ScoreReportUrl);
            }}
            label="View Score Report"
            type="online"
            icon={false}
            btnId={`home-btn-${index}`}
          />
          <Button
            onClick={() => {
              openExternalUrl({
                url: segment.ExamCo.LaunchUrl,
                contentObjectType: segment.ExamCo.ContentObjectType,
                testType: testtype,
                dispatch,
                onRefreshModalOpen:
                  screen.width > MOBILE_WIDTH && refreshModalState
                    ? (contentType) =>
                        refreshModalState((prev: any) => ({
                          ...prev,
                          isOpen: true,
                          data: contentType || segment.ExamCo.ContentObjectType || "Test",
                        }))
                    : undefined,
              });
            }}
            label="Restart Online Test"
            type="score"
            icon={false}
            btnId={`home-btn-${index}`}
          />
        </div>
      );
    }
  } else {
    if (segment.ExamCo.Status === "Not Started") {
      return (
        <div className="btn-wrapper">
          <Button
            label="Launch Class"
            type="score"
            icon={false}
            btnId={`home-btn-${index}`}
            isDisabled={true}
          />
        </div>
      );
    } else if (segment.ExamCo.Status === "In Progress") {
      return (
        <div className="btn-wrapper">
          <Button
            label="Launch Class"
            type="score"
            icon={false}
            btnId={`home-btn-${index}`}
            isDisabled={true}
          />
        </div>
      );
    } else {
      return (
        <div className="btn-wrapper">
          <Button
            onClick={() => {
              window.open(segment.RecordingUrl, "_blank");
            }}
            label="View Recording"
            type="score"
            icon={false}
            btnId={`home-btn-${index}`}
          />
        </div>
      );
    }
  }
};
